import React from 'react';
import UserAccounts from './accounts/UserAccounts';
import Plans from './plans/Plans';
import Footer from '../layouts/Footer';
import Nav from '../layouts/Nav';

const Subscribe = () => {
  return (
    <div className="container-fluid p-0" id="">
      <Nav />
      <hr className="mt-0 mb-3 d-flex d-md-none" />
      <div className="container" id="page-container">
        <UserAccounts />
        <Plans />
      </div>
      <Footer />
    </div>
  );
};

export default Subscribe;
